const context = import.meta.webpackContext('./', {
  recursive: false,
  regExp: /^\.\/(?!index\.js$).*\.js$/
})

const result = {}

context.keys().forEach(key => {
  const name = key.replace('./', '').replace(/\.js$/, '')
  if (name !== 'index') {
    result[name] = context(key).default
  }
})

export default result
